<div *ngIf="jobcard.selectedItem?.id" class="item-details-container">
    <div class="item-header">
        <div>
            <div *ngIf="jobcard.selectedItem.lastService" class="last-serviced">{{
                'bikeshop.workshop.jobcard.items.last_serviced' | translate }}: {{jobcard.selectedItem.lastService |
                date : "d MMM yyyy"}}</div>
            <div>{{jobcard.selectedItem.manufacturer}} {{jobcard.selectedItem.model}}</div>
        </div>
        <div class="actions">
            <hub-button [icon]="'pencil'" [style]="'borderless-secondary'" [size]="'lg'" [disabled]="jobcard.selectedItem?.locked"
                (buttonClick)="updateItem(jobcard.selectedItem)"></hub-button>
            <hub-button [icon]="'cross'" [style]="'borderless-secondary'" [size]="'lg'" [disabled]="jobcard.selectedItem?.locked"
                (buttonClick)="clearItem()"></hub-button>
        </div>
    </div>
    <div class="item-details">
        <div *ngIf="jobcard.selectedItem.modelYear && jobcard.selectedItem.modelYear > 0">
            {{jobcard.selectedItem.modelYear}}</div>
        <div *ngIf="jobcard.selectedItem.colour">{{jobcard.selectedItem.colour}}</div>
        <div *ngIf="jobcard.selectedItem.bikeSize">{{jobcard.selectedItem.bikeSize}}</div>
        <div *ngIf="jobcard.selectedItem.serialNo">{{jobcard.selectedItem.serialNo}}</div>
    </div>

    <!-- <div class="item-is-here">
        <hub-checkbox [(ngModel)]="jobcard.itemIsHere"
            [label]="'bikeshop.workshop.jobcard.items.the_item_is_at_the_shop' | translate"></hub-checkbox>
    </div> -->

</div>

<!-- <div class="item-bay-number" *ngIf="jobcard.selectedItem?.id > 0 && showBayNumber">
    <div>
        <hub-input [autofocus]="true" [label]="'bikeshop.workshop.jobcard.items.bay_tag_no' | translate"
            [(ngModel)]="jobcard.bayNo"></hub-input>
    </div>
    <div>
        <hub-button [icon]="'trash'" [style]="'outline'" [size]="'xl'" [disabled]="!jobcard.bayNo" [iconColor]="'#EE3158'"
            (buttonClick)="jobcard.bayNo = ''"></hub-button>
    </div>
</div> -->